/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Image, Text, View } from "@aws-amplify/ui-react";
export default function SayGoodByeMobile(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="0"
      direction="column"
      width="402px"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "SayGoodByeMobile")}
      {...rest}
    >
      <Image
        width="355.33px"
        height="451px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        borderRadius="7.516666889190674px"
        padding="0px 0px 0px 0px"
        objectFit="unset"
        {...getOverrideProps(overrides, "Image")}
      ></Image>
      <Flex
        gap="55px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="50px 20px 50px 20px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "ProcessMObile")}
      >
        <Flex
          gap="16px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Process Left")}
        >
          <Flex
            gap="24px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 110")}
          >
            <Text
              fontFamily="Inter"
              fontSize="32px"
              fontWeight="700"
              color="rgba(30,27,27,1)"
              lineHeight="49px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Say Good-Bye to the Endless Drudgery of:"
              {...getOverrideProps(
                overrides,
                "Say Good-Bye to the Endless Drudgery of:"
              )}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="400"
              color="rgba(31,31,31,1)"
              lineHeight="30px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="-0.25px"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="You’re about to experience an innovative, new roadmap so you discover the job you’ll treasure."
              {...getOverrideProps(
                overrides,
                "You\u2019re about to experience an innovative, new roadmap so you discover the job you\u2019ll treasure."
              )}
            ></Text>
          </Flex>
          <Flex
            gap="14px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464105")}
          >
            <Flex
              gap="16px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="center"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464114")}
            >
              <View
                width="28px"
                height="28px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464705763324875")}
              >
                <View
                  padding="0px 0px 0px 0px"
                  width="16.21px"
                  height="16.21px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  position="absolute"
                  top="5.89px"
                  left="5.89px"
                  {...getOverrideProps(overrides, "Group 1160463947763324876")}
                >
                  <Icon
                    width="16.21px"
                    height="16.21px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 16.210525512695312,
                      height: 16.210525512695312,
                    }}
                    paths={[
                      {
                        d: "M17.0944 0.883883L17.9783 0L16.2105 -1.76777L15.3266 -0.883883L17.0944 0.883883ZM-0.883883 15.3266L-1.76777 16.2105L0 17.9783L0.883883 17.0944L-0.883883 15.3266ZM15.3266 -0.883883L-0.883883 15.3266L0.883883 17.0944L17.0944 0.883883L15.3266 -0.883883Z",
                        stroke: "rgba(212,0,0,1)",
                        fillRule: "nonzero",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0%"
                    bottom="0%"
                    left="0%"
                    right="0%"
                    {...getOverrideProps(overrides, "Vector763324877")}
                  ></Icon>
                  <Icon
                    width="16.21px"
                    height="16.21px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 16.210525512695312,
                      height: 16.210525512695312,
                    }}
                    paths={[
                      {
                        d: "M0.883883 -0.883883L0 -1.76777L-1.76777 0L-0.883883 0.883883L0.883883 -0.883883ZM15.3266 17.0944L16.2105 17.9783L17.9783 16.2105L17.0944 15.3266L15.3266 17.0944ZM-0.883883 0.883883L15.3266 17.0944L17.0944 15.3266L0.883883 -0.883883L-0.883883 0.883883Z",
                        stroke: "rgba(212,0,0,1)",
                        fillRule: "nonzero",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0%"
                    bottom="0%"
                    left="0%"
                    right="0%"
                    {...getOverrideProps(overrides, "Vector763324878")}
                  ></Icon>
                </View>
              </View>
              <Text
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                color="rgba(11,20,31,1)"
                lineHeight="28px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Managing The Submission Process"
                {...getOverrideProps(
                  overrides,
                  "Managing The Submission Process"
                )}
              ></Text>
            </Flex>
            <Icon
              width="unset"
              height="0px"
              viewBox={{ minX: 0, minY: 0, width: 362, height: 1 }}
              paths={[
                {
                  d: "M0 0.5L362 0.5L362 -0.5L0 -0.5L0 0.5Z",
                  stroke: "rgba(221,221,221,1)",
                  fillRule: "nonzero",
                  strokeWidth: 1,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              {...getOverrideProps(overrides, "Line 3")}
            ></Icon>
            <Flex
              gap="16px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464115")}
            >
              <View
                width="28px"
                height="28px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464705763324882")}
              >
                <View
                  padding="0px 0px 0px 0px"
                  width="16.21px"
                  height="16.21px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  position="absolute"
                  top="5.89px"
                  left="5.89px"
                  {...getOverrideProps(overrides, "Group 1160463947763324883")}
                >
                  <Icon
                    width="16.21px"
                    height="16.21px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 16.210525512695312,
                      height: 16.210525512695312,
                    }}
                    paths={[
                      {
                        d: "M17.0944 0.883883L17.9783 0L16.2105 -1.76777L15.3266 -0.883883L17.0944 0.883883ZM-0.883883 15.3266L-1.76777 16.2105L0 17.9783L0.883883 17.0944L-0.883883 15.3266ZM15.3266 -0.883883L-0.883883 15.3266L0.883883 17.0944L17.0944 0.883883L15.3266 -0.883883Z",
                        stroke: "rgba(212,0,0,1)",
                        fillRule: "nonzero",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0%"
                    bottom="0%"
                    left="0%"
                    right="0%"
                    {...getOverrideProps(overrides, "Vector763324884")}
                  ></Icon>
                  <Icon
                    width="16.21px"
                    height="16.21px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 16.210525512695312,
                      height: 16.210525512695312,
                    }}
                    paths={[
                      {
                        d: "M0.883883 -0.883883L0 -1.76777L-1.76777 0L-0.883883 0.883883L0.883883 -0.883883ZM15.3266 17.0944L16.2105 17.9783L17.9783 16.2105L17.0944 15.3266L15.3266 17.0944ZM-0.883883 0.883883L15.3266 17.0944L17.0944 15.3266L0.883883 -0.883883L-0.883883 0.883883Z",
                        stroke: "rgba(212,0,0,1)",
                        fillRule: "nonzero",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0%"
                    bottom="0%"
                    left="0%"
                    right="0%"
                    {...getOverrideProps(overrides, "Vector763324885")}
                  ></Icon>
                </View>
              </View>
              <Text
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                color="rgba(11,20,31,1)"
                lineHeight="28px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Stressful Resume Sorting"
                {...getOverrideProps(overrides, "Stressful Resume Sorting")}
              ></Text>
            </Flex>
            <Icon
              width="507px"
              height="0px"
              viewBox={{ minX: 0, minY: 0, width: 507, height: 1 }}
              paths={[
                {
                  d: "M0 0.5L507 0.5L507 -0.5L0 -0.5L0 0.5Z",
                  stroke: "rgba(221,221,221,1)",
                  fillRule: "nonzero",
                  strokeWidth: 1,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              {...getOverrideProps(overrides, "Line 2")}
            ></Icon>
            <Flex
              gap="16px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464116")}
            >
              <View
                width="28px"
                height="28px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464705763324889")}
              >
                <View
                  padding="0px 0px 0px 0px"
                  width="16.21px"
                  height="16.21px"
                  display="block"
                  gap="unset"
                  alignItems="unset"
                  justifyContent="unset"
                  position="absolute"
                  top="5.89px"
                  left="5.89px"
                  {...getOverrideProps(overrides, "Group 1160463947763324890")}
                >
                  <Icon
                    width="16.21px"
                    height="16.21px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 16.210525512695312,
                      height: 16.210525512695312,
                    }}
                    paths={[
                      {
                        d: "M17.0944 0.883883L17.9783 0L16.2105 -1.76777L15.3266 -0.883883L17.0944 0.883883ZM-0.883883 15.3266L-1.76777 16.2105L0 17.9783L0.883883 17.0944L-0.883883 15.3266ZM15.3266 -0.883883L-0.883883 15.3266L0.883883 17.0944L17.0944 0.883883L15.3266 -0.883883Z",
                        stroke: "rgba(212,0,0,1)",
                        fillRule: "nonzero",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0%"
                    bottom="0%"
                    left="0%"
                    right="0%"
                    {...getOverrideProps(overrides, "Vector763324891")}
                  ></Icon>
                  <Icon
                    width="16.21px"
                    height="16.21px"
                    viewBox={{
                      minX: 0,
                      minY: 0,
                      width: 16.210525512695312,
                      height: 16.210525512695312,
                    }}
                    paths={[
                      {
                        d: "M0.883883 -0.883883L0 -1.76777L-1.76777 0L-0.883883 0.883883L0.883883 -0.883883ZM15.3266 17.0944L16.2105 17.9783L17.9783 16.2105L17.0944 15.3266L15.3266 17.0944ZM-0.883883 0.883883L15.3266 17.0944L17.0944 15.3266L0.883883 -0.883883L-0.883883 0.883883Z",
                        stroke: "rgba(212,0,0,1)",
                        fillRule: "nonzero",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                      },
                    ]}
                    display="block"
                    gap="unset"
                    alignItems="unset"
                    justifyContent="unset"
                    position="absolute"
                    top="0%"
                    bottom="0%"
                    left="0%"
                    right="0%"
                    {...getOverrideProps(overrides, "Vector763324892")}
                  ></Icon>
                </View>
              </View>
              <Text
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                color="rgba(11,20,31,1)"
                lineHeight="28px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Corresponding With Those Who Don’t Fit"
                {...getOverrideProps(
                  overrides,
                  "Corresponding With Those Who Don\u2019t Fit"
                )}
              ></Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="201.31px"
        height="122.64px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Item")}
      >
        <Flex
          gap="9.957082748413086px"
          direction="column"
          width="201.31px"
          height="122.64px"
          justifyContent="flex-start"
          alignItems="flex-start"
          overflow="hidden"
          position="absolute"
          top="0px"
          left="0px"
          border="0.47px SOLID rgba(200,211,223,1)"
          boxShadow="0px 2.6996467113494873px 2.6996467113494873px rgba(0, 0, 0, 0.25)"
          borderRadius="10.79858684539795px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 1160464556")}
        >
          <Image
            width="267px"
            height="164.5px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            objectFit="cover"
            {...getOverrideProps(overrides, "image 18")}
          ></Image>
        </Flex>
      </Flex>
      <Image
        width="186.21px"
        height="45px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        objectFit="cover"
        {...getOverrideProps(overrides, "image 19")}
      ></Image>
    </Flex>
  );
}
